import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";

import { SearchInput } from "@digital-services/ui";

import { isSearchQueryValueValid } from "@resource/utils";

import { useResourcesContext } from "../context/useResourcesContext";

export const SearchResources = () => {
  const [isSearchValid, setIsSearchValid] = useState<boolean>();

  // Note
  // No injection here of PaginationContext to be able to reset after search, as result NO issue with Pagination.
  // Maybe it should be injected here, pay attention to avoid call of `setSearchQuery()` from <ResourcesContextProvider> because it will break <PageControls>.

  const { searchQuery, setSearchQuery, searchHasError, setSearchHasError } =
    useResourcesContext();

  const { t } = useTranslation(undefined, {
    keyPrefix: "resources"
  });

  const handleSearchInput = useCallback(
    (newValue: string) => {
      if (newValue) {
        const isValidInput = isSearchQueryValueValid(newValue);
        setIsSearchValid(isValidInput);

        if (isValidInput) {
          // Note that here it may be single string value or string value with `;` or `,` separator.
          setSearchQuery(newValue);
        }
      } else {
        setSearchQuery("");
        setSearchHasError(false);
        setIsSearchValid(true);
      }
    },

    // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [searchQuery]
  );

  const showError = isSearchValid === false || searchHasError;

  return (
    <div className="w-[550px]">
      <SearchInput
        data-testid="search-resource"
        placeholder={t("search.placeholder")}
        onChange={handleSearchInput}
      />

      {showError && (
        <div className="mt-2 flex w-full text-red-600">
          <p className="text-sm">{t("search.invalid-input-error-message")}</p>
        </div>
      )}
    </div>
  );
};
